import { IActionData } from 'models/common';

export interface IArticleSettings {
	id?: string;
	listed?: boolean;
	//commentsEnabled?: boolean;
	onlyForMembers?: boolean;
	entityId?: string;
}

export class ArticleSettings implements IArticleSettings {
	public id?: string;
	public listed?: boolean;
	//public commentsEnabled?: boolean;
	public onlyForMembers?: boolean;
	public entityId?: string;
}

export interface IManageArticleSettings extends IActionData {
	articleSettings: IArticleSettings;
}

export interface IManageArticleSettingsAction {
	type: string;
	payload?: {
		message?: any;
		articleSettings?: IArticleSettings;
	};
}
